<button
    type="button"
    placement="bottom"
    class="btn btn--paybee mdb-shared-popover shared-link-event"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
>
    <span id="{{getLinkId('Invitations', event)}}">Send Invitations</span>
    <i class="fas fa-share ml-1"></i>
</button>

<ng-template #content>
  <div class="popover-links">
    <div
        *ngIf="event.type === 1"
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickSendInvitation(event, event.type, 0)"
    >
        <i class="far fa-copy mr-2"></i>
        <div>Send Invitation</div>
    </div>
    <div
        *ngIf="event.type < 2"
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickSendInvitation(event, event.type, 1)"
    >
        <i class="far fa-copy mr-2"></i>
        <div>Send Event Page Invitation</div>
    </div>
    <div
        *ngIf="event.type === 2"
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickSendInvitation(event, 1, 0)"
    >
        <i class="far fa-copy mr-2"></i>
        <div>Send (Virtual) Invitation</div>
    </div>
    <div
        *ngIf="event.type === 2"
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickSendInvitation(event, 0, 1)"
    >
        <i class="far fa-copy mr-2"></i>
        <div>Send Event Page Invitation</div>
    </div>
  </div>
</ng-template>



